<template>
  <v-menu
      :close-on-content-click="false"
      :disabled="disabled"
      :nudge-right="40"
      full-width
      lazy
      min-width="290px"
      offset-y
      ref="menu"
      transition="scale-transition"
      v-model="menu"
  >
    <v-text-field
        :disabled="disabled"
        :label="label"
        :required="required"
        @blur="dateInputFocused = false"
        @focus="dateInputFocused = true"
        prepend-icon="event"
        readonly
        slot="activator"
        v-bind="$attrs"
        :value="displayDate"
        :clear-icon-cb="handleClearClick"
    ></v-text-field>
    <v-date-picker
        :allowedDates="allowedDates"
        :disabled="disabled"
        :first-day-of-week="1"
        :locale="locale"
        :title-date-format="titleDateFormat"
        :value="datePickerValue"
        @input="onDateSelected"
        :event-color="eventsColor"
        :events="events"
        no-title
        :day-format="formatDay"
        scrollable>
      <template v-if="!autoclose">
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="menu = false">
          {{ $t('message.common.cancel') }}
        </v-btn>
        <v-btn flat color="primary" @click="$refs.menu.save(value)">
          {{ $t('message.common.accept') }}
        </v-btn>
      </template>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';
import HasCalendarEventsEndpoint from '@/components/date/mixins/has-calendar-events-endpoint';

export default {
  name: 'nx-date-picker',
  mixins: [HasCalendarEventsEndpoint],
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
    },
    minDate: {
      type: String,
    },
    maxDate: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    autoclose: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      dateInputFocused: false,
    };
  },
  computed: {
    displayDate() {
      if (!this.value) return null;
      return moment(this.value).format('DD/MM/YYYY');
    },
    datePickerValue() {
      if (!this.value) return null;
      return moment(this.value).format('YYYY-MM-DD');
    },
    locale() {
      return 'es';
    },
    allowedDates() {
      const minDate = moment(this.minDate || null);
      const maxDate = moment(this.maxDate || null);

      const minDateObj = minDate.isValid() ? moment(minDate.format('YYYY-MM-DD')) : minDate;
      const maxDateObj = maxDate.isValid() ? moment(maxDate.format('YYYY-MM-DD')) : maxDate;
      if (!minDateObj.isValid() && !maxDateObj.isValid()) {
        return null;
      }

      return (date) => {
        let allowed = true;
        if (minDateObj.isValid() && minDateObj.isAfter(date)) allowed = false;
        if (maxDateObj.isValid() && maxDateObj.isBefore(date)) allowed = false;
        return allowed;
      };
    },
    focused() {
      return this.dateInputFocused || this.menu;
    },
  },

  watch: {
    focused(focused) {
      const event = focused ? 'focus' : 'blur';
      this.$emit(event, focused);
    },
  },

  methods: {
    onDateSelected(newValue) {
      if (this.autoclose) {
        this.menu = false;
      }
      if (newValue === null) {
        this.$emit('input', null);
        return;
      }
      this.$emit('input', moment(newValue).format());
    },
    handleClearClick() {
      this.$emit('input', null);
    },
    titleDateFormat(date, locale) {
      return (new Date(date)).toLocaleDateString(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      }).replace(/\./g, '');
    },
  },
};
</script>
